import api from './api';

/**
 * Section Service
 * Handles all section and task-related API operations
 */
const sectionService = {
  /**
   * Get all sections with their tasks
   * @param {Object} options - Query options
   * @param {boolean} options.active - Filter by active status
   * @returns {Promise<Object>} Sections with tasks
   */
  getSections: async (options = {}) => {
    try {
      const { active } = options;
      
      // Build query parameters
      const params = new URLSearchParams();
      if (active !== undefined) params.append('active', active);
      
      const queryString = params.toString();
      const url = `/sections${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      console.log('sectionService: Raw API response:', response);
      console.log('sectionService: Response data structure:', response.data);
      console.log('sectionService: Response data type:', typeof response.data);
      console.log('sectionService: Response data keys:', Object.keys(response.data || {}));
      return response.data;
    } catch (error) {
      console.error('Error fetching sections:', error);
      throw error.message || 'Failed to fetch sections';
    }
  },
  
  /**
   * Initialize default sections and tasks
   * @returns {Promise<Object>} Result of initialization
   */
  initializeSectionsAndTasks: async () => {
    try {
      const response = await api.post('/sections/init');
      return response.data;
    } catch (error) {
      console.error('Error initializing sections and tasks:', error);
      throw error.message || 'Failed to initialize sections and tasks';
    }
  },
  
  /**
   * Update section roles and active status
   * @param {Array} sectionUpdates - Array of section updates with roles and active status
   * @returns {Promise<Object>} Updated sections result
   */
  updateSectionRoles: async (sectionUpdates) => {
    try {
      const response = await api.put('/sections/roles', { sections: sectionUpdates });
      return response.data;
    } catch (error) {
      console.error('Error updating section roles:', error);
      throw error.message || 'Failed to update section roles';
    }
  },
  
  /**
   * Get a single section by ID
   * @param {string} sectionId - Section ID
   * @returns {Promise<Object>} Section data
   */
  getSectionById: async (sectionId) => {
    try {
      const response = await api.get(`/sections/${sectionId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching section ${sectionId}:`, error);
      throw error.message || 'Failed to fetch section';
    }
  },
  
  /**
   * Get tasks for a specific section
   * @param {string} sectionId - Section ID
   * @returns {Promise<Object>} Tasks for the section
   */
  getSectionTasks: async (sectionId) => {
    try {
      const response = await api.get(`/sections/${sectionId}/tasks`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching tasks for section ${sectionId}:`, error);
      throw error.message || 'Failed to fetch section tasks';
    }
  }
};

export default sectionService;